document.addEventListener('mouseover', function (e) {
  var swatch = e.target.closest('.card__color-swatch');
  if (!swatch) return;
  var img = document.getElementById(swatch.dataset.targetImg);
  if (img && swatch.dataset.swapSrc) {
    if (img.dataset.originalSrcset === undefined) {
      img.dataset.originalSrcset = img.getAttribute('srcset') || '';
    }
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = swatch.dataset.swapSrc;
  }
});

// Only reset the image when the cursor leaves the whole swatch row,
// not when moving between individual swatches inside it.
document.addEventListener('mouseout', function (e) {
  var container = e.target.closest('.card__color-swatches');
  if (!container) return;
  if (container.contains(e.relatedTarget)) return;

  var firstSwatch = container.querySelector('.card__color-swatch');
  if (!firstSwatch) return;
  var img = document.getElementById(firstSwatch.dataset.targetImg);
  if (img && img.dataset.originalSrc) {
    img.src = img.dataset.originalSrc;
    if (img.dataset.originalSrcset) {
      img.setAttribute('srcset', img.dataset.originalSrcset);
    }
  }
});

document.addEventListener('click', function (e) {
  var swatch = e.target.closest('.card__color-swatch');
  if (!swatch) return;
  if (swatch.dataset.variantUrl) {
    window.location.href = swatch.dataset.variantUrl;
  }
});
